import React from 'react';

const MarketAdjustmentLedgerContext = React.createContext({});

export default MarketAdjustmentLedgerContext;
